import { graphql } from "./__generated__/gql";

export const EVENT_BY_SLUG_QUERY = graphql(`
  query EventBySlug($slug: String!) {
    eventCollection(filter: { slug: { eq: $slug } }, first: 1) {
      edges {
        node {
          id
          title
          description
          slug
          status
          visibility
          starts_at
          ends_at
          flyer_url
          location_name
          location_street
          location_city
          location_state
          location_postal_code
          location_geo
          location_place_id
          location_neighborhood
          event_ticket_kindCollection {
            edges {
              node {
                id
                currency
                description
                name
                price_cents
                price_service_fee
                quantity_total
                quantity_sold
              }
            }
          }
          event_memberCollection {
            edges {
              node {
                user_id
                role
                rsvp_status
              }
            }
          }
        }
      }
    }
  }
`);
